function deepFreeze(value) {
  if (!value || (typeof value !== "object" && typeof value !== "function") || Object.isFrozen(value)) {
    return value;
  }
  Object.freeze(value);
  for (const nestedValue of Object.values(value)) deepFreeze(nestedValue);
  return value;
}

export const ACCOUNT_ELIGIBILITY_POLICY = deepFreeze({
  policyId: "exiled-systems-signup-eligibility-guardrails",
  version: "draft-2026-07-21.1",
  status: "required-before-registration",
  effective: false,
  failClosed: true,
  serverAuthorityRequired: true,
  publicSelfRegistration: {
    roleAuthority: "server-only",
    acceptsClientStaffClaim: false,
    staffReservedNamePath: "future-server-approved-staff-workflow-only",
  },
  age: {
    minimumAge: 18,
    maximumAgeExclusive: 99,
    supportedRangeLabel: "18 through 98",
    outOfRangeMessage:
      "Sorry, that date is outside the currently supported age range. Enter your actual date of birth or contact staff.",
  },
  email: {
    exactDomainMatchRequired: true,
    domainNormalization: "trim-ascii-lowercase-only",
    acceptedProviders: [
      { label: "Gmail", domain: "gmail.com" },
      { label: "Yahoo", domain: "yahoo.com" },
      { label: "MSN", domain: "msn.com" },
      { label: "Hotmail", domain: "hotmail.com" },
      { label: "AOL", domain: "aol.com" },
    ],
    allowedDomains: ["gmail.com", "yahoo.com", "msn.com", "hotmail.com", "aol.com"],
    unsupportedProviderMessage:
      "Sorry, we currently accept Gmail, Yahoo, MSN, Hotmail, or AOL email addresses only.",
    accessReminder:
      "Use an email inbox you can access. We'll send a verification link, and your account will stay locked until you confirm it.",
    verificationGuarantee: "inbox-access-only",
  },
  publicIdentity: {
    coveredFields: ["displayName", "handle"],
    normalization: "unicode-nfkc-casefold-remove-separators-and-zero-width",
    reservedBrandTokens: ["exile", "exiled"],
    publicSelfRegistrationRule: "reserved-for-server-approved-staff",
    clientStaffBypassAllowed: false,
    ordinaryUserBrandUse: "blocked",
    brandedDisparagement: "blocked-all-roles",
    enforcementAuthority: "server",
    staffBrandExceptionAuthority: "server-authoritative-verified-staff-role",
    reservedBrandMessage:
      "Exile and Exiled names are reserved for staff accounts approved by the server.",
    abusiveBrandedNames: {
      noBypass: true,
      blockedTerms: ["sucks", "stinks"],
      message: "That name cannot be used.",
    },
  },
  requiredActivationGates: [
    "reservedBrandIdentityPolicyEnforced",
    "supportedAgeRangePolicyEnforced",
    "approvedEmailProviderPolicyEnforced",
  ],
});

export function isAccountEligibilityPolicyReady(
  registrationState,
  policy = ACCOUNT_ELIGIBILITY_POLICY,
) {
  return Boolean(
    policy?.effective === true
      && policy?.serverAuthorityRequired === true
      && policy?.failClosed === true
      && policy?.requiredActivationGates?.every((key) => registrationState?.[key] === true),
  );
}
